import { useEffect} from "react";
import { SidebarProvider } from "../../Context/SidebarContext";
import Loader from "../../components/Loader";
import { useGetProductsQuery } from "../../redux/api/productsApi.js";
import BodyContent from "./BodyContent";
import ProductsTable from "./ProductsTable";
import SidebarCategory from "../Category/SidbarCategory";
import ResultsShownFilter from "./ResultsShownFilter";
import CategoryNav from "./CategoryNav";
import { toast } from "react-hot-toast";

// Pagination
import CustomPagination from "../../components/layout/CustomPagination";
import { useSearchParams } from "react-router-dom";


import {
  useGetparentCategoryQuery,
  useGetSubCategoryQuery,
} from "../../redux/api/categoryApi";

import MetaData from "../../components/layout/MetaData";



const ProductsPage = () => {
  let [searchParams] = useSearchParams();
  const page = Number(searchParams.get("page")) || 1;
  const select = Number(searchParams.get("select"));
  const keyword = searchParams.get("keyword") || "";
  const params = { page, keyword, select };

  //TODO: check if category is not null and add it to params object
  const category = searchParams.get("category");
  category !== null && (params.category = category);

  const { data, isLoading, isError, error } = useGetProductsQuery(params);
  const { data: products, totalCount, paginationResult, results } = data || [];

  const { data: parentCategory, isLoading: isLoadingParent } =
    useGetparentCategoryQuery(params);
  const { data: subCategory, isLoading: isLoadingSub } =
    useGetSubCategoryQuery(params);


  useEffect(() => {
    if (isError) {
      toast.error(error?.data?.message);
    }
  }, [isError, error?.data?.message]);

  return (
    <SidebarProvider>
      <>
        <MetaData title="All-Products" />
        <main className="px-2 sm:px-[50px] md:px-[100px] bg-[#F5F9FF]">
          <CategoryNav product={{ category: subCategory?.name || parentCategory?.name }} />
          <article className="w-full min-h-[70vh] flex flex-col md:flex-row gap-12">
            <div className="hidden md:block">
              <SidebarCategory
                isLoadingSub={isLoadingSub}
                parentCategory={parentCategory}
                subCategory={subCategory}
                isLoadingParent={isLoadingParent}
              />
            </div>
            <section className="flex flex-col flex-1 shrink-0 min-w-0">
              {keyword ? (
                <>
                  <div className="flex flex-row items-center justify-between py-2">
                    <h1 id="products_heading" className="text-gray-500 text-sm font-medium">
                      {products?.length || 0} Results shown for: <span className="text-gray-700 font-bold">{keyword}</span>
                    </h1>
                  </div>
                </>
              ) : (
                <div className={keyword ? "w-1/2 md:w-3/4" : "w-1/2 md:w-full"}>
                  <h1 id="products_heading" className="text-gray-500 text-sm font-medium">
                    {keyword ? (
                      `${
                        products?.length || 0
                      } Products Found With keyword: ${keyword}`
                    ) : (
                      <BodyContent
                        subCategory={subCategory}
                        parentCategory={parentCategory}
                        isLoadingParent={isLoadingParent}
                      />
                    )}
                  </h1>
                </div>
              )}
              {isLoading && <Loader />}
              <ResultsShownFilter
                resPerPage={paginationResult}
                filteredProductsCount={totalCount}
              />
              <ProductsTable products={products} />
              <CustomPagination
                resPerPage={paginationResult}
                results={results}
                filteredProductsCount={totalCount}
              />
              <ResultsShownFilter
                resPerPage={paginationResult}
                filteredProductsCount={totalCount}
              />
              <CustomPagination
                resPerPage={paginationResult}
                filteredProductsCount={totalCount}
              />
            </section>
          </article>
        </main>
      </>
    </SidebarProvider>
  );
};

export default ProductsPage;
